import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../components/Table";
import PaymentItem from "./PaymentItem";
import EmptyStatus from "../../components/EmptyStatus";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {Query} from "react-apollo";
import {GET_CHARGE_PAYMENTS} from "../../queries/customers";

class PaymentsList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedId: ""
    }
  }

  render() {
    let params = {accountId: this.props.accountId, salesOrderId: this.props.salesOrderId}
    let tableHeader = List([
      "Occured At",
      "Type",
      "Amount",
      "Method",
      "Result",
      "Ref",
      "Stripe Payment Method",
      "Stripe Payment Intent",
    ])
    
    return (
      <Query query={GET_CHARGE_PAYMENTS} variables={params} pollInterval={this.props.pollInterval}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          let charges = fromJS(data.billingChargePayments);
          if (charges.size === 0) {
            return <EmptyStatus status="No payments found" />
          }
          
          return (
            <div>
              <Table 
                data={charges} 
                mode="table"
                renderer={PaymentItem} 
                tableHeader={tableHeader}
                itemKey="createdAt"
                />
            </div>
          )
        }}
      </Query>
    )
  }

}

PaymentsList.defaultProps = {
  accountId: "",
  pollInterval: 5000
}

export default connect(null, {})(PaymentsList);